import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
export const IconWarning = forwardRef<HTMLElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path
            fill="#111928"
            fillRule="evenodd"
            d="M11.372 4.5a1 1 0 0 1 1.732 0l7.505 13a1 1 0 0 1-.866 1.5H4.733a1 1 0 0 1-.867-1.5zm1.755 3.833H11.35v5.334h1.777zm-2.223 8a1.333 1.333 0 1 1 2.667 0 1.333 1.333 0 0 1-2.667 0"
            clipRule="evenodd"
        />
    </Icon>
));
IconWarning.displayName = "IconWarning";
